import getPeople from '../../data_management/getPeople'

export default class ManageMembersController {
  constructor($scope, members, requestChangeToList, initialDataInteractor, close) {
    this.$scope = $scope;
    this.members = members;
    this.requestChangeToList = requestChangeToList;
    this.initialDataInteractor = initialDataInteractor;
    this.close = close;

    this.loadMembers();
  }

  updateMembers(updatedMemberList) {
    return this.requestChangeToList(updatedMemberList).then(() => {
      this.members = updatedMemberList;
      this.loadMembers();
    });
  }

  loadMembers() {
    return this.initialDataInteractor.ensureInitializedSession()
      .then(() => {
        let people = getPeople(this.initialDataInteractor);
        let memberIds = this.members.map(m => m.id);
        this.nonMembers = people.filter(p => !memberIds.includes(p.id));
        //This ensures that the members are loaded with data that only the coach should have, like email.
        this.members = people.filter(p => memberIds.includes(p.id));
        this.$scope.$digest();
      });
  }
}